import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { PlatformTourHighlight } from './PlatformTourHighlight'
import { tourHighlightsHeadingSx, tourHighlightsSx, tourPlainListSx } from './platformTourStyles'

/** "On this page": what the stop's page holds, one line each. */
export const PlatformTourHighlights: React.FC<{ highlightKeys: string[] }> = ({ highlightKeys }) => {
  const { t } = useTranslation()

  return (
    <Box sx={tourHighlightsSx}>
      <Box sx={tourHighlightsHeadingSx}>{t('gamer.platformTour.onThisPage')}</Box>
      <Box component="ul" sx={tourPlainListSx}>
        {highlightKeys.map((highlightKey) => (
          <PlatformTourHighlight key={highlightKey} text={t(highlightKey)} />
        ))}
      </Box>
    </Box>
  )
}
